import React from "react";

const Legend = ({ children }) => {
  return <legend>{children}</legend>;
};

export default Legend;
